import { render, staticRenderFns } from "./ButtonModal.vue?vue&type=template&id=23cf9123&scoped=true&"
import script from "./ButtonModal.vue?vue&type=script&lang=js&"
export * from "./ButtonModal.vue?vue&type=script&lang=js&"
import style0 from "./ButtonModal.vue?vue&type=style&index=0&id=23cf9123&scoped=true&lang=scss&"
import style1 from "./ButtonModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf9123",
  null
  
)

export default component.exports